/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Filterdisabledwhileshowingselected5Inputs */

const en_coinvestments_prospects_filterdisabledwhileshowingselected5 = /** @type {(inputs: Coinvestments_Prospects_Filterdisabledwhileshowingselected5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off "Show selected only" to use filters`)
};

/**
* | output |
* | --- |
* | "Turn off \"Show selected only\" to use filters" |
*
* @param {Coinvestments_Prospects_Filterdisabledwhileshowingselected5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_filterdisabledwhileshowingselected5 = /** @type {((inputs?: Coinvestments_Prospects_Filterdisabledwhileshowingselected5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Filterdisabledwhileshowingselected5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_filterdisabledwhileshowingselected5(inputs)
});
export { coinvestments_prospects_filterdisabledwhileshowingselected5 as "coInvestments_prospects_filterDisabledWhileShowingSelected" }